import { richTextResolver } from "@website-builder/utilities-index";

export default ({ text }, { globalVariableWithURL = [] }) => {
	const richText = richTextResolver(text, globalVariableWithURL);
	return {
		textInHtml: richText,
	};
};
